<template>
  <v-container style="margin: 0 auto; max-width: 1300px;">
    <!-- Dialog for viewing image fullscreen -->
    <v-dialog v-model="dialog" width="90%">
      <v-card>
        <img
          @click="selectSticker(sticker)"
          v-bind:src="activePicture"
          alt
          style="width: 100%;"
          class="shadow"
        />
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div
      class="mt-4 ml-2 mr-2"
      style="background-color: rgb(240, 240, 240); border: 1px solid rgb(130, 130, 130); border-radius: 5px; padding: 20px; margin: 0 auto; box-shadow: 0 0 10px rgb(150, 150, 150);"
    >
      <v-row no-gutters>
        <v-col cols="12" sm="2" md="1" lg="1">
          <div id="thumbnailBox">
            <img
              @click="changeActivePicture(1)"
              v-bind:src="sticker.image1"
              alt
              style="width: 100%; cursor: pointer;"
              class="productIcon shadow mb-1"
            />
            <img
              @click="changeActivePicture(2)"
              v-bind:src="sticker.image2"
              alt
              style="width: 100%; cursor: pointer;"
              class="productIcon shadow mb-1"
            />
            <img
              @click="changeActivePicture(3)"
              v-bind:src="sticker.image3"
              alt
              style="width: 100%; cursor: pointer;"
              class="productIcon shadow mb-1"
            />
          </div>
        </v-col>
        <v-col cols="12" sm="10" md="7" lg="7" class="pr-4 pl-4">
          <img
            @click="dialog = true"
            v-bind:src="activePicture"
            alt
            style="width: 100%;"
            class="shadow"
          />
        </v-col>

        <v-col cols="12" sm="12" md="4" lg="4">
          <h1
            style="text-align: center; text-transform: uppercase; line-height: 1.1;"
          >{{sticker.title}}</h1>
          <p
            v-if="sticker.kind == '1 pack'"
            style="text-align: center; color: rgb(100, 100, 100); margin: 0px; padding: 0px;"
          >Sticker - 1 pack</p>
          <p
            v-if="sticker.kind == '5 pack'"
            style="text-align: center; color: rgb(100, 100, 100); margin: 0px; padding: 0px;"
          >Sticker - 5 pack</p>
          <p
            v-if="sticker.kind == '10 pack'"
            style="text-align: center; color: rgb(100, 100, 100); margin: 0px; padding: 0px;"
          >Sticker - 10 pack</p>
          <v-row no gutters style="margin: 0 auto; text-align: center;">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              style="margin: 0 auto; text-align: center; max-width: 400px;"
            >
              <div
                v-if="sticker.kind == '1 pack'"
                class="ml-2 mr-2 mt-0"
                style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150); text-align: center; margin: 0 auto;"
              >
                <v-select
                  v-model="selectedSize1pack"
                  :items="onePackOptions"
                  label="Sizes"
                  class="ml-2 mr-2"
                  color="green"
                ></v-select>
              </div>

              <div
                v-if="sticker.kind == '5 pack'"
                class="ml-2 mr-2 mt-0"
                style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150); text-align: center; margin: 0 auto;"
              >
                <v-select
                  v-model="selectedSize5pack"
                  :items="fivePackOptions"
                  label="Sizes"
                  class="ml-2 mr-2"
                  color="green"
                ></v-select>
              </div>

              <div
                v-if="sticker.kind == '10 pack'"
                class="ml-2 mr-2 mt-0"
                style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150); text-align: center; margin: 0 auto;"
              >
                <v-select
                  v-model="selectedSize10pack"
                  :items="tenPackOptions"
                  label="Sizes"
                  class="ml-2 mr-2"
                  color="green"
                ></v-select>
              </div>
            </v-col>
            <v-col no-gutters cols="12" sm="12" md="12" lg="12" style="margin: 0px; padding: 0px;">
              <v-row style="max-width: 220px; margin: 0 auto;">
                <v-col cols="4">
                  <v-btn
                    class="mb-2"
                    style="box-shadow: 0 0 5px rgb(150, 150, 150); "
                    color="error"
                    @click="decreaseQuantity"
                  >-</v-btn>
                </v-col>
                <v-col cols="4">
                  <v-btn
                    class="mb-2"
                    style="box-shadow: 0 0 5px rgb(150, 150, 150)"
                    color="grey lighten-3"
                  >{{quantity}}</v-btn>
                </v-col>
                <v-col cols="4">
                  <v-btn
                    class="mb-2"
                    style="box-shadow: 0 0 5px rgb(150, 150, 150)"
                    color="success"
                    @click="increaseQuantity"
                  >+</v-btn>
                </v-col>
              </v-row>
              <v-btn
                class="ml-2 mr-5"
                style="box-shadow: 0 0 5px rgb(150, 150, 150); width:100%; max-width: 300px;"
                color="success"
                @click="addToCart"
              >Add to Cart</v-btn>
              <div v-if="this.addedToCart">
                <v-btn
                  class="ml-2 mr-5 mt-2"
                  style="box-shadow: 0 0 5px rgb(150, 150, 150); width:100%; max-width: 300px; height: 80px;"
                  color="warning"
                  @click="goToCart"
                >
                  Sticker Added to Cart!
                  <br />Go To Cart
                </v-btn>
              </div>
              <p @click="home" style="padding: 0px;" class="mt-3 mb-0 link">Continue Browsing</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div style="max-width: 1100px; margin: 0 auto;">
      <div class="ml-5 mr-5">
        <h2 style="padding-top: 20px;">Free Shipping!</h2>

        <div style="height: 1px; width: 100%;background-color: black;" class="mb-2"></div>

        <p>All of our stickers are shipped for free anywhere in the US!</p>
        <p>Your sticker will be printed in 1 business day and will arrive after 2-5 business days of shipping.</p>
        <p>We do not currently ship internationally.</p>

        <h2>Quality Stickers</h2>

        <div style="height: 1px; width: 100%;background-color: black;" class="mb-2"></div>

        <p>We use quality sticker paper so the designs look sharp and vibrant!</p>
        <p>Our stickers are water resistant, but are not completely waterproof. Prolonged exposure to water can lead to damage.</p>

        <h2>Customer Service</h2>

        <div style="height: 1px; width: 100%;background-color: black;" class="mb-2"></div>

        <p>If you have any questions just visit our FAQ's page. If you don't find an answer there, you can send us a message on that page.</p>

        <h2 class="productTitle">Replacement Stickers</h2>

        <div style="height: 1px; width: 100%;background-color: black;" class="mb-2"></div>

        <p>We offer replacements for damaged items. If you receive a sticker that was damaged during shipping, just email us a picture of the issue and we will work quickly to send you another sticker.</p>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    error: "",
    addedToCart: false,
    activePicture: null,
    sticker: null,
    selectedSize1pack: "2in - $2",
    selectedSize5pack: "2in - $8",
    selectedSize10pack: "2in - $16",
    onePackOptions: [
      "2in - $2",
      "4in - $3",
      "6in - $5",
      "8in - $8",
      "10in - $10"
    ],
    fivePackOptions: [
      "2in - $8",
      "4in - $12",
      "6in - $20",
      "8in - $30",
      "10in - $40"
    ],
    tenPackOptions: [
      "2in - $16",
      "4in - $25",
      "6in - $35",
      "8in - $50",
      "10in - $70"
    ],
    quantity: 1
  }),
  mounted() {
    this.scrollToTop();
    this.sticker = this.$store.state.selectedSticker;
    this.activePicture = this.sticker.image1;
    // Make url correct so that it works if a user sends someone else this link
    history.pushState(null, null, `/?sticker=${this.sticker.slug}`);
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    goToCart() {
      this.$router.push("/cart");
    },
    home() {
      this.$router.push("/");
    },
    changeActivePicture(number) {
      if (number == 1) {
        this.activePicture = this.sticker.image1;
      } else if (number == 2) {
        this.activePicture = this.sticker.image2;
      } else {
        this.activePicture = this.sticker.image3;
      }
    },
    increaseQuantity() {
      this.quantity++;
    },
    decreaseQuantity() {
      if (this.quantity > 1) {
        this.quantity--;
      }
    },
    addToCart() {
      this.addedToCart = true;
      this.$store.dispatch("addToTotalInCart", this.quantity);
      let price = 0;
      let size = "2in";
      switch (this.sticker.kind) {
        case "1 pack":
          switch (this.selectedSize1pack) {
            case "2in - $2":
              price = 200;
              size = "2in";
              break;
            case "4in - $3":
              price = 300;
              size = "4in";
              break;
            case "6in - $5":
              price = 500;
              size = "6in";
              break;
            case "8in - $8":
              price = 800;
              size = "8in";
              break;
            case "10in - $10":
              price = 1000;
              size = "10in";
              break;
          }
          this.$store.dispatch("addToCart", {
            title: this.sticker.title,
            thumbnail: this.sticker.thumbnail,
            size: size,
            quantity: this.quantity,
            price: price,
            kind: this.sticker.kind,
            itemID: this.sticker.id
          });
          break;
        case "5 pack":
          switch (this.selectedSize5pack) {
            case "2in - $8":
              price = 800;
              size = "2in";
              break;
            case "4in - $12":
              price = 1200;
              size = "4in";
              break;
            case "6in - $20":
              price = 2000;
              size = "6in";
              break;
            case "8in - $30":
              price = 3000;
              size = "8in";
              break;
            case "10in - $40":
              price = 4000;
              size = "10in";
              break;
          }
          this.$store.dispatch("addToCart", {
            title: this.sticker.title,
            size: size,
            quantity: this.quantity,
            price: price,
            kind: this.sticker.kind,
            itemID: this.sticker.id
          });
          break;
        case "10 pack":
          switch (this.selectedSize10pack) {
            case "2in - $16":
              price = 1600;
              size = "2in";
              break;
            case "4in - $25":
              price = 2500;
              size = "4in";
              break;
            case "6in - $35":
              price = 3500;
              size = "6in";
              break;
            case "8in - $50":
              price = 5000;
              size = "8in";
              break;
            case "10in - $70":
              price = 7000;
              size = "10in";
              break;
          }
          this.$store.dispatch("addToCart", {
            title: this.sticker.title,
            size: size,
            quantity: this.quantity,
            price: price,
            kind: this.sticker.kind,
            itemID: this.sticker.id
          });
          break;
      }
    }
  }
};
</script>

<style scoped>
.shadow {
  border: 1px solid grey;
  box-shadow: 5px 5px 5px grey;
}

@media only screen and (max-width: 600px) {
  .productIcon {
    width: 50px !important;
    margin-right: 15px;
  }

  #thumbnailBox {
    margin: 0 auto;
    text-align: center;
    margin-bottom: 10px;
  }
}

.link {
  color: rgb(57, 93, 255);
  margin-bottom: 0px;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
